import type { APIPortal } from "models/types/api-listing";
import DollarIcon from "assets/icons/medium/dollar.svg?react";
import GBPIcon from "assets/icons/medium/gbp.svg?react";
import { useRegion } from "hooks/use-region";

type Region = APIPortal["region"]["id"];
type Locale = "en-AU" | "en-GB";
type Currency = "AUD" | "GBP";

const REGION_CONFIGURATIONS: Record<
  Region,
  { locale: Locale; currency: Currency }
> = {
  AUS: {
    locale: "en-AU",
    currency: "AUD",
  },
  GBR: {
    locale: "en-GB",
    currency: "GBP",
  },
} as const;

const REGION_CURRENCY_ICONS = {
  AUS: DollarIcon,
  GBR: GBPIcon,
};

export const useFormatMoney = () => {
  const region = useRegion();

  return (amount: number | null | undefined): string => {
    if (amount === null || amount === undefined) return "–";
    const config = REGION_CONFIGURATIONS[region] || REGION_CONFIGURATIONS.AUS;
    return new Intl.NumberFormat(config.locale, {
      style: "currency",
      currency: config.currency,
      minimumFractionDigits: 0,
    }).format(amount);
  };
};

/**
 * This is to convert amount from cents, it will divide the amount by 100
 */
export const useFormatMoneyCentsConverter = () => {
  const formatMoney = useFormatMoney();
  return (amount: number | null | undefined) => {
    if (amount === null || amount === undefined) return "-";
    return formatMoney(amount / 100);
  };
};

export const useCurrencyIcon = () => {
  const region = useRegion();
  return REGION_CURRENCY_ICONS[region];
};
